import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
    paper: {
      position: 'absolute',
      width: `${50}%`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: 0,
      top: `${40}%`,
      left: `${50}%`,
      right: 'auto',
      bottom: 'auto',   
      transform: `translate(-${50}%, -${50}%)`
    },
  });

class OpenModal extends Component {
    constructor(props){
       super(props);
       this.state = {
           modalIsOpen:false
       }
    }

 componentWillReceiveProps(nextProps){
     this.setState({
        modalIsOpen:nextProps.modalIsOpen
     })
 }  
 
 
render(){
    const {customStyles,classes} = this.props;
    const {modalIsOpen}  = this.state;
    let declineMsg = [];
    if(this.props.modalMessage !== undefined && this.props.modalMessage.includes('You have')){
      declineMsg = this.props.modalMessage.split('#;');
    }
    return (
        <Modal
          open={modalIsOpen}         
          onClose={this.props.closeModal} disableBackdropClick={true} disableEscapeKeyDown={true}>
          <div className={classes.paper} >
         <div className="payment-portal-modal">
         {this.props.modalMessage === 'loading' ? 
          <div className="image-360">
          <div className="image-360-header" style={{textAlign: "center"}}>Payment Portal</div>
          <div className="image-360-rotation" style={{textAlign: "center"}}>
           <Typography>Payment is in progress. Please wait...</Typography>         
         </div>
         </div>:
        <div style={{textAlign: "center"}}> 
        <div className="image-360">
        <div className="image-360-header" style={{textAlign: "center"}}>{this.props.modalMessage === 'refreshHandling' ? 'Session Timeout' : 'Payment Portal'}</div>
        <div className="image-360-rotation">
        <Typography>
    {this.props.modalMessage === 'exportPDF' ? <span>Please print out a receipt of your payment for your records using the <span style={{fontSize: '20px', color: '#fa451c', cursor: 'pointer'}} onClick={this.props.exportPdf}>EXPORT TO PDF</span> button on this page. A copy of this receipt has also been emailed to you.</span> : this.props.modalMessage === 'refreshHandling'?<span style={{color: '#0070C0',fontSize:'17px'}}>Are you still working?<br/><br/>Your session will refresh in 2mins. Would you like to continue working?</span> : this.props.modalMessage === 'ccservicefeecancel' ? <span style={{color: '#0070C0',fontSize:'17px'}}>To support our Retailers through this difficult time, we are <span style={{textDecoration:'underline',textDecorationColor:'#fa451c',textUnderlinePosition:'under',textDecorationStyle:'Solid'}}>waiving</span> our 2.5% convenience fee on your credit card payment - you will not incur any fees for cc payments. Thank you for being a trusted Gabriel Partner!</span> : (this.props.modalMessage !== undefined && this.props.modalMessage.includes('You have')) ? <span style={{color: '#fa451c',fontSize:'16px'}}>{declineMsg[1]}<p style={{marginBottom: '0px'}}>{declineMsg[0]}</p></span> : this.props.modalMessage}
       
        </Typography></div>
       </div>
       <Button variant="contained" className="modal-padding" style={{backgroundColor: this.props.modalMessage === 'refreshHandling' ? '#0070C0' : '#fa451c'}}
       color="primary" onClick={this.props.closeOnClick}>{this.props.modalMessage === 'refreshHandling' ? "Continue Session" :"Ok"}
                      </Button>
                      {this.props.modalMessage === 'refreshHandling' ?
                      <Button variant="contained" className="modal-padding"
       color="primary" onClick={this.props.refreshOnClick}>Refresh
                      </Button>:''}             
                      </div>
                      
        }                                
        </div></div>       
        </Modal>
    )
}
};


OpenModal.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(OpenModal);


// WEBPACK FOOTER //
// ./src/OpenModal.js